import { Injectable } from '@angular/core';
import { SourceAppProfilAcheteurInfos } from '../../../models/source-app-profil-acheteur-infos';
import { TypeAnn } from '../../formulaires/common/models/type.ann';
import { Avis } from '../../../models/avis';

@Injectable({
  providedIn: 'root'
})
export class AvisDataTransferService {

  public sourceAppProfilAcheteurInfos: SourceAppProfilAcheteurInfos;
  public refConsultation: String;
  public siret: string;
  public typeAnn: TypeAnn = null;
  public avis: Avis =  null;
  public jsonCSV = {};
  public contenuPdf = null;
  public noticeProcedureID : string[] = [];
  public reference: any[] = [];
  public refAvisLie: any[] = [];
  public diffuseurID;
  public pageSize: number = 5;
  public page: number = 0;

  constructor() { }

  setFormData(data: any): void {
    this.avis = data;
  }

  getFormData(): any {
    return this.avis;
  }
}
